import { APP_NAME } from '@/const/core'

export const setDocumentTitle = (title: string) => {
  document.title = `${title} | ${APP_NAME}`
}
